<template>


  <div class="container">
    <div class="handle-box-search">





      <el-button type="primary" icon="el-icon-search" @click="searchAdvertAppointLists">搜索</el-button>

      <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>

<!--      <el-button @click="refresh">同步</el-button>-->

    </div>

    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header"
      @selection-change="handleSelectionChange">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <div class="more-style">

              <el-form-item label="创建时间:">
                <span>{{ props.row.time.Ymd }}</span>
              </el-form-item>

              <el-form-item label="创建详细时间:">
                <span>{{ props.row.time.YmdHis }}</span>
              </el-form-item>

              <el-form-item label="修改时间:">
                <span>{{ props.row.edit_time.Ymd }}</span>
              </el-form-item>

            </div>

            <div class="more-style">

              <el-form-item label="修改详细时间:">
                <span>{{ props.row.edit_time.YmdHis }}</span>
              </el-form-item>

              <el-form-item label="唯一编码:">
                <span>{{ props.row.advert_appoint_code }}</span>
              </el-form-item>

              <el-form-item label="可选择指针信息:">
                <span>{{ props.row.advert_key }}</span>
              </el-form-item>

            </div>


            <el-form-item label="备注:">
              <span>{{ props.row.remarks }}</span>
            </el-form-item>


          </el-form>
        </template>
      </el-table-column>


      <el-table-column prop="id" label="id" width="80">
      </el-table-column>

      <el-table-column prop="name" label="名称" min-width="200">
      </el-table-column>




      <el-table-column prop="time.Ymd" label="创建时间">
      </el-table-column>

      <el-table-column prop="edit_time.Ymd" label="修改时间">
      </el-table-column>

      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button split-button type="primary"
            @click="saveAdvert_isShow=!saveAdvert_isShow; saveAdvert_drawer = scope.row.advert_appoint_code;">

            绑定广告位

          </el-button>
        </template>
      </el-table-column>





    </el-table>


    <!-- 分页组件 -->
    <div class="pagination">

      <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>

    </div>

    <!-- 绑定广告组件 -->
    <saveAdvert :isShow="saveAdvert_isShow" :data="saveAdvert_drawer" @onSubmit="advertAppointLists"></saveAdvert>


    <!-- 详情组件 -->
    <advertAppointMore :isShow="advert_more" :data="advert_appoint_code"></advertAppointMore>


  </div>


</template>

<script>
  var _this;
  import saveAdvert from './saveAdvert.vue';
  import advertAppointMore from './advertAppointMore.vue';
  export default {
    components: {
      saveAdvert,
      advertAppointMore
    },
    data() {
      return {

        // 详情开关
        advert_more: false,

        // 详情组件内容
        advert_appoint_code: '',



        advert_key: {},
        // 绑定广告组件开关
        saveAdvert_isShow: false,

        // 传入绑定广告位置组件的内容
        saveAdvert_drawer: {},





        // 存放表格数据
        tableData: [],

        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
        },

        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          },
        },
      };
    },
    created() {
      _this = this;

      _this.advertAppointLists();




    },

    methods: {
      searchAdvertAppointLists(){

        _this.search_data.page = 1;
        _this.advertAppointLists();

      },





      // 获取模式
      advertAppointLists() {


        _this.$post(
            "/advert/advertAppointLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {

            // 将请求的数据存放到表格数据数组中
            _this.tableData = res.data;
            _this.result_data = res;

            // _this.advert_key = res.data.advert_key;


          }).catch((err) => {

          })

      },

      //翻页组件的回调
      pages_function(search_data) {

        //赋值
        _this.search_data = search_data;

        //初始化列表
        _this.advertAppointLists();

      },

      handleSelectionChange(val) {

        var datalist = [];

        for (var i in val) {

          datalist.push(val[i].advert_code);

        }
        _this.delAdvertSubmit_data.advert_code = datalist;
      },





      // 刷新按钮
      refresh() {
        this.$router.go(0);
      },

    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }

  .el-dropdown {
    vertical-align: top;
  }

  .el-dropdown+.el-dropdown {
    margin-left: 15px;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>